import { OnOffEnum } from '@/constants/enums';

export function getPoweredOnState(poweredOn: OnOffEnum | string): boolean {
  if (poweredOn == null) {
    return true;
  }

  // Convert to string first to safely call toLocaleLowerCase (handles numeric values for backward compatibility)
  const poweredOnString =
    typeof poweredOn === 'string' ? poweredOn.toLocaleLowerCase() : String(poweredOn).toLocaleLowerCase();

  switch (poweredOnString) {
    case OnOffEnum.On:
      return true;
    case OnOffEnum.Off:
      return false;
  }

  // TODO: this is a backward compatibility to support numeric / numeric string value ("0" or "1")
  // TODO: we need to remove this support once we are sure that all the indicators have
  // TODO: value-mappings defined
  return !!Number(poweredOn);
}
